import React from 'react'
import classes from './SelectorItem.module.sass'
import { TypeSelectorItem } from '../../../../../types/interfaces'

type Props = {
  el: TypeSelectorItem
  onClick: (value: number) => void
  value: number[]
}

const SelectorItem = ({ el, onClick, value }: Props) => {
  return (
    <div
      className={value.includes(el.id) ? classes.ContainerActive : classes.Container}
      onClick={() => onClick(el.id)}
    >
      {el.name}
    </div>
  )
}

export default SelectorItem
